import React from 'react'
import landing from '../../../assets/images/landing.jpg'
import {HeroDiv} from './style'


function Hero() {
    return (
        <HeroDiv  style={{ backgroundImage: `url(${landing})` }}>
            <div className="inner-container">
                <div className="banner pt-5">
                    <div className="yourhealthbox">
                        <h2>Contact Us.</h2>
                        <p>We are never far from u.</p>
                    </div>  
                </div>
            </div> 
        </HeroDiv>
    )
}

export default Hero
